export function generateFallbackColor() {
  return { r: 52, g: 144, b: 239 }
}
